module.exports = __webpack_public_path__ + "img/makemytrip-logo.44f334f7.svg";